import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NotificationPreferences } from "./NotificationPreferences";
import { Profile } from "../types";

interface UserProfileDialogProps {
  profile: Profile | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const UserProfileDialog = ({
  profile,
  open,
  onOpenChange,
}: UserProfileDialogProps) => {
  if (!profile) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{profile.full_name || "User Profile"}</DialogTitle>
        </DialogHeader>
        <Tabs defaultValue="details" className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="details">Details</TabsTrigger>
            <TabsTrigger value="notifications">Notifications</TabsTrigger>
          </TabsList>
          <TabsContent value="details" className="space-y-4">
            <div className="space-y-2">
              <div>
                <span className="text-sm font-medium">Email:</span>
                <p className="text-sm text-muted-foreground">{profile.email || "N/A"}</p>
              </div>
              <div>
                <span className="text-sm font-medium">Roles:</span>
                <p className="text-sm text-muted-foreground">
                  {profile.user_roles.map(r => r.role).join(", ") || "No roles"}
                </p>
              </div>
            </div>
          </TabsContent>
          <TabsContent value="notifications">
            <NotificationPreferences userId={profile.id} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
